import { Directive, Input, HostBinding, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[subFeaturePermission]'
})
export class SubFeaturePermissionDirective {

  @Input() private readonly subFeaturePermission: string | [string];
  @Output() private readonly featureDisabled: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _disabled = true;

  constructor() { }

  getPermission(): string | [string] {
    return this.subFeaturePermission;
  }

  @HostBinding('attr.disabled') get isDisabled() { return this._disabled ? '' : null; }

  set disabled(val: boolean) {
    this._disabled = val;
    this.featureDisabled.emit(val);
  }

}
